import type { SettlementUserDetailsResponse } from '@/entities/settlement/api/settlement.api';
import { downloadXlsx } from '@/shared/utils/xlsxExport';

/** 레거시 `settlementUserDetailsXLSXHeaderMap` — 엑셀 한글 헤더 */
export const SETTLEMENT_USER_DETAILS_EXPORT_HEADERS: Record<string, string> = {
  settlementId: '정산 ID',
  prescriptionYearMonth: '처방년월',
  settlementYearMonth: '정산 년월',
  email: '사용자 이메일',
  ceoName: '대표자명',
  phoneNumber: '전화번호',
  pharmaCompanyName: '제약사명',
  clinicName: '병의원명',
  drugName: '의약품명',
  drugCode: '의약품 코드',
  price: '약가',
  totalQuantity: '처방 수량',
  totalAmount: '처방 금액',
  prescriptionApprovalStatus: '처방 승인 상태',
  pharmaCompanySettlementStatus: '제약사 정산 상태',
  commissionRate: '수수료율',
  finalAmount: '확정 금액',
  remarks: '비고',
};

/** 정산 export API 응답을 한글 헤더 엑셀로 저장 */
export const downloadSettlementUserDetailsCsv = (
  rows: SettlementUserDetailsResponse[],
  settlementYearMonth: string,
) => {
  if (rows.length === 0) return;

  const mapped = rows.map((row) => {
    const out: Record<string, unknown> = {};
    for (const [key, label] of Object.entries(
      SETTLEMENT_USER_DETAILS_EXPORT_HEADERS,
    )) {
      out[label] = row[key as keyof SettlementUserDetailsResponse];
    }
    return out;
  });

  downloadXlsx(mapped, `정산정보_${settlementYearMonth}.xlsx`);
};
